export default function features(patchedFeatures, originalImplementation) {
  return (...args) => ({
    ...(originalImplementation(...args) || {}),
    ...(patchedFeatures || {}),
  });
}
